// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointsResponseItemFromJSON, DatapointsResponseItemToJSON, } from './';
export function DatapointsComparisonResponseItemFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'entities': !exists(json, 'entities') ? undefined : json['entities'].map(DatapointsResponseItemFromJSON),
    };
}
export function DatapointsComparisonResponseItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'entities': value.entities === undefined ? undefined : value.entities.map(DatapointsResponseItemToJSON),
    };
}
